import {
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { RuntimeConfigService } from '../config/runtime-config.service';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

export const loggerCallback = (level: LogLevel, message: string, containsPii: boolean) => {
  if (containsPii) return;
  switch (level) {
    case LogLevel.Error:
      console.error(message);
      return;
    case LogLevel.Info:
      console.info(message);
      return;
    case LogLevel.Verbose:
      console.debug(message);
      return;
    case LogLevel.Warning:
      console.warn(message);
      return;
  }
};

export function MSALInstanceFactory(runtime: RuntimeConfigService): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: runtime.authClientId,
      authority: `https://login.microsoftonline.com/${runtime.authTenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(
  runtime: RuntimeConfigService
): MsalInterceptorConfiguration {
  const protectedResourceMap: [string, string[]][] = [[runtime.graphApi, [runtime.scopes]]];

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map<string, Array<string>>(protectedResourceMap),
  };
}

export function MSALGuardConfigFactory(runtime: RuntimeConfigService): MsalGuardConfiguration {
  const scope = runtime.scopes;
  const scopes = [scope];
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes,
    },
    loginFailedRoute: '/unauthorized',
  };
}
